import { useContext } from "react";
import { AlertContext } from "components/AlertProvider/AlertProvider";

export const useAlert = () => useContext(AlertContext);
